import React, { useState, useEffect } from "react";

interface Props {
  title: string;
  subTitle?: string;
  body: JSX.Element;
  id: string;
}

const Modal = ({ title, subTitle, body, id }: Props) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [dontShowAgain, setDontShowAgain] = useState<boolean>(false);

  const handleClose = () => {
    const item = localStorage.getItem(id);

    if (dontShowAgain && !item) {
      localStorage.setItem(id, "true");
    }

    setShowModal(false);
  };

  useEffect(() => {
    const item = localStorage.getItem(id);

    if (!item) {
      setShowModal(true);
    }
  }, []);

  return (
    <React.Fragment>
      {showModal && (
        <div className="h-screen w-full fixed flex-col z-50 items-center justify-center bg-teal-lightest font-sans">
          <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50" />

          <div className="h-screen w-full absolute flex items-center justify-center bg-modal">
            <div className="bg-white rounded shadow p-6 m-4 w-11/12 md:max-w-md mx-auto max-h-full text-left overflow-y-scroll">
              <div className="flex justify-between items-center pb-3">
                <p className="text-gray-800 text-2xl font-bold">{title}</p>
                <div className="cursor-pointer z-50" onClick={handleClose}>
                  <svg
                    className="fill-current text-black"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                  >
                    <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
                  </svg>
                </div>
              </div>
              {subTitle && (
                <p className="text-gray-800 text-1xl font-bold">{subTitle}</p>
              )}

              {body}

              <div className="flex justify-between pt-2">
                <label className="md:w-2/3 block text-gray-500 font-bold">
                  <input
                    className="mr-2 leading-tight"
                    type="checkbox"
                    checked={dontShowAgain}
                    onChange={() => setDontShowAgain(!dontShowAgain)}
                  />
                  <span className="text-sm">Nicht mehr anzeigen</span>
                </label>
                <button
                  className="bg-yellow-500 rounded-full shadow-lg py-2 px-4 font-bold text-gray-800"
                  onClick={handleClose}
                >
                  Schließen
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Modal;
